// extracted by mini-css-extract-plugin
export var dropdownButton = "_3k-0";
export var fullWidthDropdownButton = "_3k-1";
export var icon = "_3k-3";
export var iconPlaceholder = "_3k-2";
export var menuItemRow = "_3k-5";
export var shortcutContainer = "_3k-4";